<template>
  <div class="modal fade" id="edit-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="closeReturnModal" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title">{{'change_address' | translate}}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-xs-8">
              <h5>{{address.delivery_first_name}} {{address.delivery_last_name}}</h5>
              <p>{{address.delivery_address_line_1}}
                <template v-if="address.delivery_address_line_2 !== ''">
                  <br/>
                  {{address.delivery_address_line_2}}
                </template>
                <template v-if="address.delivery_address_line_3 !== ''">
                  <br/>
                  {{address.delivery_address_line_3}}
                </template><br>{{address.delivery_zip_code}}, {{address.delivery_city}}<br>Germany</p>
            </div>
            <div class="col-xs-4">
              <select class="form-control" v-model="addressType">
                <option class="normal" value="hausadresse">{{'home_address' | translate}}</option>
                <option class="normal" value="packstation">{{'packstation' | translate}}</option>
                <option class="normal" value="postfiliale">{{'post_store' | translate}}</option>
              </select>
            </div>
          </div>
          <hr>
          <div class="row">
            <div class="form-group col-sm-6 col-xs-12">
              <label class="pull-left">{{'first_name' | translate}}*</label>
              <input v-validate="''" data-vv-as="First Name" class="form-control" name="corrected_first_name" placeholder="First Name" type="text" v-model="address.corrected_first_name">
              <span v-show="errors.has('corrected_first_name')" class="small text-danger">{{ errors.first('corrected_first_name') }}</span>
            </div>
            <div class="form-group col-sm-6 col-xs-12">
              <label class="pull-left">{{'last_name' | translate}}*</label>
              <input v-validate="''" data-vv-as="Last Name" class="form-control" name="corrected_last_name" placeholder="Last Name" type="text" v-model="address.corrected_last_name">
              <span v-show="errors.has('corrected_last_name')" class="small text-danger">{{ errors.first('corrected_last_name') }}</span>
            </div>
          </div>
          <div class="row" v-if="addressType === 'hausadresse'">
            <div class="form-group col-sm-10 col-xs-12">
              <label class="pull-left">{{'street' | translate}}*</label>
              <input v-validate="''" data-vv-as="Street" class="form-control" name="corrected_street" placeholder="Street" type="text" v-model="address.corrected_street">
              <span v-show="errors.has('corrected_street')" class="small text-danger">{{ errors.first('corrected_street') }}</span>
            </div>
            <div class="form-group col-sm-2 col-xs-12">
              <label class="pull-left">{{'shipping_street_no' | translate}}*</label>
              <input v-validate="''" data-vv-as="Street No." class="form-control" name="corrected_street_number" placeholder="Nr." type="text" v-model="address.corrected_street_number">
              <span v-show="errors.has('corrected_street_number')" class="small text-danger">{{ errors.first('corrected_street_number') }}</span>
            </div>
          </div>
          <div class="row" v-else>
            <div class="form-group col-sm-10 col-xs-12 hidden">
              <label class="pull-left">{{'street' | translate}}*</label>
              <input class="form-control" name="corrected_street" placeholder="Street" type="text" v-model="address.corrected_street">
            </div>
            <div class="form-group col-sm-12 col-xs-12">
              <label class="pull-left">{{getLabel() | translate}}:</label>
              <input v-validate="''" data-vv-as="Street No." class="form-control" name="corrected_street_number" placeholder="Care of" type="text" v-model="address.corrected_street_number">
              <span v-show="errors.has('corrected_street_number')" class="small text-danger">{{ errors.first('corrected_street_number') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6 col-xs-12" v-if="addressType === 'hausadresse'">
              <label class="pull-left">{{'company' | translate}}:</label>
              <input v-validate="''" data-vv-as="Company" class="form-control" name="corrected_company" placeholder="Company" type="text" v-model="address.corrected_company">
              <span v-show="errors.has('corrected_company')" class="small text-danger">{{ errors.first('corrected_company') }}</span>
            </div>
            <div :class="['form-group', 'col-xs-12', addressType === 'hausadresse' ? 'col-sm-6' : '']">
              <label class="pull-left">Postnummer*</label>
              <input v-validate="''" data-vv-as="Care of" class="form-control" name="corrected_care_of" placeholder="Nr." type="text" v-model="address.corrected_care_of">
              <span v-show="errors.has('corrected_care_of')" class="small text-danger">{{ errors.first('corrected_care_of') }}</span>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-4 col-xs-12">
              <label class="pull-left">{{'zip_code' | translate}}:</label>
              <input v-validate="''" data-vv-as="ZIP code" class="form-control" name="corrected_zip" placeholder="ZIP" type="text" v-model="address.corrected_zip">
              <span v-show="errors.has('corrected_zip')" class="small text-danger">{{ errors.first('corrected_zip') }}</span>
            </div>
            <div class="form-group col-sm-8 col-xs-12">
              <label class="pull-left">{{'city' | translate}}:</label>
              <input v-validate="''" data-vv-as="City" class="form-control" name="corrected_city" placeholder="City" type="text" v-model="address.corrected_city">
              <span v-show="errors.has('corrected_city')" class="small text-danger">{{ errors.first('corrected_city') }}</span>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeModal" class="btn btn-app btn-outline no-margin pull-left" data-dismiss="modal"><span class="fa fa-times"></span>{{'cancel' | translate($parent.$store.getters.language)}}</button>
          <button type="button" :disabled="errors.any()" class="btn btn-app btn-info no-margin" @click="send()"><span class="fa fa-refresh "></span>{{'retry' | translate($parent.$store.getters.language)}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['address', 'client', 'id'],
  data () {
    return {
      addressType: ''
    }
  },
  methods: {
    getLabel () {
      return this.addressType === 'postfiliale' ? 'post_store' : this.addressType === 'hausadresse' ? 'care_of' : 'packstation'
    },
    send () {
      if (this.addressType !== 'hausadresse') {
        this.address.corrected_street = this.addressType
        this.address.corrected_company = ''
      }
      API.put(`/orders/${this.id}/customer/address`, this.address)
        .then(response => {
          $('#closeModal').click()
          this.$parent.loading = true
          this.$emit('alert', response)
        })
        .catch(error => {
          $('#closeModal').click()
          this.$emit('alert', error)
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  watch: {
    address () {
      this.addressType = this.address.corrected_street === 'packstation' || this.address.corrected_street === 'postfiliale' ? this.address.corrected_street : 'hausadresse'
    }
  }
}
</script>
